export default __webpack_public_path__ + "static/media/My_account.ea29732d.svg";